import { c as _c } from "react/compiler-runtime";
import { Badge, InlineAlert, Skeleton, Tabbar } from '@systemeio/components';
import { InfoCircleIcon } from '@systemeio/icons';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { usePageForms } from 'modules/automation-rules/triggers/hooks/use-page-forms';
import { AutomationRuleErrorInterface } from 'modules/automation-rules/types/automation-rule-interface';
import React, { useEffect, useState } from 'react';
import { FormSelect } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
enum TriggerFormPageTypeEnum {
  Field = 'field',
  Form = 'form',
}
interface TriggerFormItemProps {
  pageId: number | undefined;
  form: {
    id: string;
    name: string;
  } | null | undefined;
  onFormChange: (form: {
    id: string;
    name: string;
  } | null) => void;
  onOpen: (slug: AutomationRuleTriggersDataEnum) => void;
  errors: AutomationRuleErrorInterface;
  triggerId: number;
}
export const TriggerFormItem = t0 => {
  const $ = _c(61);
  const {
    pageId,
    form,
    onFormChange,
    onOpen,
    errors,
    triggerId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [value, setValue] = useState(form?.id ? TriggerFormPageTypeEnum.Form : TriggerFormPageTypeEnum.Field);
  const {
    pageFormData,
    isPageFormListLoading
  } = usePageForms(pageId, value === TriggerFormPageTypeEnum.Form);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.automation_rule.form_field");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isPageFormListLoading || $[3] !== t1) {
    t2 = {
      children: t1,
      disabled: isPageFormListLoading,
      value: TriggerFormPageTypeEnum.Field
    };
    $[2] = isPageFormListLoading;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.automation_rule.form_element");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("global.label_new");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <Badge className="uppercase" color="green" shape="rounded" size="sm">{t4}</Badge>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("dashboard.automation_rule.form_element");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isPageFormListLoading || $[17] !== t6 || $[18] !== t7) {
    t8 = {
      children: t6,
      disabled: isPageFormListLoading,
      overflowLabel: t7,
      value: TriggerFormPageTypeEnum.Form
    };
    $[16] = isPageFormListLoading;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t2 || $[21] !== t8) {
    t9 = [t2, t8];
    $[20] = t2;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const formPageTypeData = t9;
  let t10;
  let t11;
  if ($[23] !== form) {
    t10 = () => {
      setValue(form ? TriggerFormPageTypeEnum.Form : TriggerFormPageTypeEnum.Field);
    };
    t11 = [form];
    $[23] = form;
    $[24] = t10;
    $[25] = t11;
  } else {
    t10 = $[24];
    t11 = $[25];
  }
  useEffect(t10, t11);
  const isFormElementSelected = value === TriggerFormPageTypeEnum.Form;
  const hasFormElements = pageFormData?.length !== 0;
  let t12;
  if ($[26] !== t) {
    t12 = t("dashboard.automation_rule.form_field");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("dashboard.automation_rule.form_element");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const t14 = `${t12} / ${t13}`;
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      className: "w-full"
    };
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== form || $[32] !== onFormChange) {
    t16 = data => {
      const nextValue = data as TriggerFormPageTypeEnum;
      setValue(nextValue);
      if (nextValue === TriggerFormPageTypeEnum.Field && form !== null) {
        onFormChange(null);
      }
    };
    $[31] = form;
    $[32] = onFormChange;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      className: "flex-1 py-2"
    };
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== formPageTypeData || $[36] !== t14 || $[37] !== t16 || $[38] !== value) {
    t18 = <Tabbar aria-label={t14} listProps={t15} onValueChange={t16} tabProps={t17} tabs={formPageTypeData} value={value} variant="segmented" />;
    $[35] = formPageTypeData;
    $[36] = t14;
    $[37] = t16;
    $[38] = value;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== hasFormElements || $[41] !== isFormElementSelected || $[42] !== isPageFormListLoading || $[43] !== t) {
    t19 = isPageFormListLoading ? <FormElementSkeleton /> : <InlineAlert variant="neutral"><InlineAlert.Icon><InfoCircleIcon aria-hidden={true} /></InlineAlert.Icon><InlineAlert.Content><InlineAlert.Description className="text-text-secondary text-base">{isFormElementSelected ? t(hasFormElements ? "dashboard.automation_rule.trigger_via_form_element_description" : "dashboard.automation_rule.form_elemant_list_empty") : t("dashboard.automation_rule.trigger_via_field_form_description")}</InlineAlert.Description></InlineAlert.Content></InlineAlert>;
    $[40] = hasFormElements;
    $[41] = isFormElementSelected;
    $[42] = isPageFormListLoading;
    $[43] = t;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== errors || $[46] !== form?.id || $[47] !== form?.name || $[48] !== hasFormElements || $[49] !== isFormElementSelected || $[50] !== isPageFormListLoading || $[51] !== onFormChange || $[52] !== onOpen || $[53] !== pageFormData || $[54] !== t || $[55] !== triggerId) {
    t20 = isFormElementSelected && !isPageFormListLoading && hasFormElements ? <FormSelect disabled={isPageFormListLoading} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.form_subscribed_element_page)} value={form?.id} staticData={[{
      id: form?.id ?? "",
      caption: form?.name ?? ""
    }]} data={pageFormData} onChange={formId => {
      if (!formId) {
        return;
      }
      const selectedForm = pageFormData?.find(f => f.id === formId);
      onFormChange({
        id: formId,
        name: selectedForm?.caption ?? ""
      });
    }} label={t("dashboard.automation_rule.form_element_title")} placeholder={t("dashboard.automation_rule.form_element_placeholder")} error={errors.automationTriggers[triggerId]?.formId?.join("")} withoutCloseIcon={true} /> : null;
    $[45] = errors;
    $[46] = form?.id;
    $[47] = form?.name;
    $[48] = hasFormElements;
    $[49] = isFormElementSelected;
    $[50] = isPageFormListLoading;
    $[51] = onFormChange;
    $[52] = onOpen;
    $[53] = pageFormData;
    $[54] = t;
    $[55] = triggerId;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== t18 || $[58] !== t19 || $[59] !== t20) {
    t21 = <div className="flex flex-col gap-2">{t18}{t19}{t20}</div>;
    $[57] = t18;
    $[58] = t19;
    $[59] = t20;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  return t21;
};
const FormElementSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-16 w-full rounded-lg" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};